import React from 'react'

import SkeletonLoader from '@common/components/SkeletonLoader'

const SimulationSkeleton = () => {
  return <SkeletonLoader width="100%" height={78.4} />
}

export default SimulationSkeleton
